
export const aliases = {
  Porter: 'Stout',
  ['Stærk Pilsner']: 'Pilsner',
  ['Mørk Pilsner']: 'Classic',
  ['India Pale Ale']: 'IPA',
  ['Rød Ale']: 'Mørk Ale',
};

export default type => aliases[type] || type;
